import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useRef } from 'react';
import { useSelector , useDispatch } from 'react-redux';
import { updateCvFile } from '../../../redux/actions/certificateVerification';
import { toast } from 'react-toastify';
import { SET_USER_CV_DATA } from '../../../redux/actions/types';
import { Mixpanel } from '../../../config/Mixpanel';
import Constants from '../../../common/constants';


const FileUploader = () => {
  const fileInputRef = useRef(null);
  const userLinkedInProfile = useSelector((store)=> store?.certificateVerification?.user_linked_url);
  const userDetails = useSelector((store) => store?.certificateVerification?.userInfo);
  const dispatch= useDispatch();
  const cvData = useSelector((store)=> store?.certificateVerification?.cvData);
  const [uploadState, setUploadState] = useState(cvData?.name ? 'uploaded'  : 'initial'); // 'initial', 'uploading', 'uploaded'
  const [selectedFile, setSelectedFile] = useState(cvData?.name ?  {name : cvData?.name} : null);
  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/pdf') {
      setSelectedFile(file);
      uploadFile(file);
    } else {
      alert('Please select a PDF file only');
    }
  };

  const uploadFile = async (file) => {
    setUploadState('uploading');
    
   
     dispatch(updateCvFile(userDetails?.email , file , (successObj)=>{
      setUploadState("uploaded");

      dispatch({type : SET_USER_CV_DATA , payload : successObj?.data?.user_cv})
     } , (errorObj)=>{
      toast.error("Failed to upload file");
      setUploadState("initial");
      
     }))
    
  };

  const handleClick = () => {
    if (uploadState === 'initial') {
      fileInputRef.current?.click();
    }
  };

  const handleReplace = () => {
   Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_OWNER_PAGE_REPLACE_CV_BUTTON_CLICKED, { distinct_id: userDetails?.email })
    fileInputRef.current?.click();
  };

  const resetUpload = () => {
    setUploadState('initial');
    setSelectedFile(null);
  };
  
  // Initial State
  if (uploadState === 'initial') {
    return (
      <div className="w-full mx-auto leading-tight cursor-pointer" onClick={(e)=> Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_OWNER_PAGE_UPLOAD_CV_BUTTON_CLICKED, { distinct_id: userDetails?.email })}>
        <div 
          className="bg-[#18345A] border-dashed border-[1px] border-[#73A7FF]/50 rounded-lg px-3 py-4 text-center cursor-pointer"
          onClick={handleClick}
        >
          <input
            ref={fileInputRef}
            type="file"
            accept=".pdf,application/pdf"
            onChange={handleFileSelect}
            className="hidden"
          />
          <img src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/meteor-icons_upload-cloud.png?updatedAt=1750661175936" className="w-7 h-7 mx-auto" alt="" />
          <p className="text-white text-[14px] font-normal mt-4">
            Click here to upload
          </p>
          <p className="text-white/50 text-[12px] mt-[6px]">
            pdf, docx accepted
          </p>
        </div>
      </div>
    );
  }

  // Uploading State
  if (uploadState === 'uploading') {
    return (
      <div className="w-full mx-auto leading-tight cursor-pointer">
        <div className="bg-[#18345A] border-dashed border-[1px] border-[#73A7FF]/50 rounded-lg px-3 py-4 flex justify-start items-center cursor-pointer">
          <input
            ref={fileInputRef}
            type="file"
            accept=".pdf,application/pdf"
            onChange={handleFileSelect}
            className="hidden"
          />
          <div className="w-[28px] h-[28px] bg-[#2BBD13]/10 rounded-full mr-4"></div>
          <div className="flex-1">
            <p className="text-white font-normal text-[14px] md:text-[16px]">File Uploading...</p>
            <p className="text-white/50 text-[12px] md:text-[14px] mt-[6px]">{selectedFile?.name || "FileName"}</p>
          </div>
        </div>
      </div>
    );
  }

  // Uploaded State  
  if (uploadState === 'uploaded') {
    return (
      <div className="w-full mx-auto leading-tight cursor-pointer">
        <div className="bg-[#18345A] border-dashed border-[1px] border-[#73A7FF]/50 rounded-lg px-3 py-4 flex justify-start items-center cursor-pointer">
        <input
          ref={fileInputRef}
          type="file"
          accept=".pdf,application/pdf"
          onChange={handleFileSelect}
          className="hidden"
        />
        <div className='flex-1 flex justify-start items-center'>
          <div className="w-[28px] h-[28px] bg-[#2BBD13]/10 rounded-full mr-4 flex justify-center items-center">
          <FontAwesomeIcon className="text-[#2BBD13]" icon={faCheck} size='lg'/>
          </div>
          <div className="flex-1">
            <p className="text-white font-normal text-[14px] md:text-[16px]">File Uploaded</p>
            <p className="text-white/50 text-[12px] md:text-[14px] mt-[6px]">{selectedFile?.name || "FileName"}</p>
          </div>
          </div>
          <div className='text-[12px] md:text-[14px] font-medium text-white/70 underline underline-offset-2' onClick={handleReplace}>Replace</div>
        </div>
      </div>
    );
  }
};

export default FileUploader;